<template>
  <div id="bm-team-player-permit" >
    <div class="cert-guide">
      <van-icon name="warning-o" style="position: relative;top: 2px;"/>
      长按屏幕轻松下载球员参赛证
    </div>
    <div id="canvas-permit" class="cert-box">
      <img class="cert-card" :src="bgImg" />
      <div class="cert-content">
        <img class="cert-avatar" :src="profileImg" @click="doImage" />
        <div class="cert-text-box">
          <div class="cert-text">
            <span class="cert-label">姓名</span>
            <span class="cert-value">{{query.name}}</span>
          </div>
          <div class="cert-text">
            <span class="cert-label">球衣</span>
            <span class="cert-value">{{query.number}}</span>
          </div>
          <div class="cert-text">
            <span class="cert-label">球队</span>
            <span class="cert-value">{{query.team}}</span>
          </div>
          <div class="cert-text">
            <span class="cert-label">注册号</span>
            <span class="cert-value">{{query.serialNumber}}</span>
          </div>
        </div>
      </div>
      <div class="canvas-bg">
        <img id="canvas-img" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, Button, Popup, Picker, Toast, Icon, Loading } from 'vant'
import { ImageFormat } from '@/utils/'
import html2canvas from 'html2canvas'

Vue.use(Cell).use(CellGroup).use(Button).use(Popup).use(Picker).use(Toast).use(Icon).use(Loading)

export default {
  name: 'PlayerPermit',
  data () {
    return {
      query: ''
    }
  },
  computed: {
    profileImg() {
      return ImageFormat.imageView(this.query.avatar, 240, 340)
    },
    bgImg() {
      return ImageFormat.imageView('http://images.snsports.cn/hfa_player_card_bg.png', 750, 1334)
    }
  },
  created() {
    this.query = this.$route.query
  },
  mounted() {
    setTimeout(() => {
      this.doImage()
    }, 1000)
  },
  methods: {
    doImage() {
      html2canvas(document.querySelector('#canvas-permit'),
        {useCORS: true})
        .then(function(canvas) {
          const dataUrl = canvas.toDataURL()
          document.querySelector('#canvas-img').setAttribute('src', dataUrl)
        })
    }
  }
}
</script>

<style lang="stylus">
  #bm-team-player-permit
    background-color: white
    width 100%
    user-select: none
    .canvas-bg
      position absolute
      top 0
      #canvas-img
        width 100%
    .cert-box
      width 100%
      position relative
      .cert-card
        width 100%
      .cert-content
        position absolute
        top 37%
        left: 50%
        transform: translateX(-50%)
        width 100%
        .cert-avatar
          width 120px
          height 170px
          display block
          margin 0 auto
          border-radius 5px
        .cert-text-box
          padding-top 20px
          padding-left 31%
          .cert-text
            padding 6px 0
            .cert-label
              color #999999
              font-size 16px
            .cert-value
              color #323232
              padding-left 15px
              font-size 16px
              font-weight 500
    .cert-guide
      position: fixed;
      top: 0px;
      text-align: center;
      margin: 0 auto;
      left: 50%;
      transform: translateX(-50%);
      font-size 12px;
      background-color: #e6a23c;
      color: #FFF;
      padding 4px
      width 100%
      z-index: 99;
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/player/permit.vue